module.exports = __webpack_public_path__ + "img/default.dbe6e19.png";